<form [formGroup]="form">
  <section>
    <span class="section-title">{{ "shared.media" | translate }}</span>
    <div class="images-grid">
      <app-single-image-or-video-uploader
        [type]="type"
        [control]="form.controls.image"
        [form]="form"
        [fields]="fields"
        [brandId]="brandId"
      />
    </div>
    <span class="info">
      <mat-icon>info_outline</mat-icon>
      <span>
        {{
          "publicationTemplate.create.instagramSingleImage.image.moreInfo"
            | translate
        }}
      </span>
    </span>
  </section>
  <section>
    <span class="section-title">{{ "shared.text" | translate }}</span>
    <span class="section-description">{{
      "publicationTemplate.create.instagramSingleImage.text.description"
        | translate
    }}</span>
    <app-publication-text-editor [control]="form.controls.text" />
  </section>
</form>
